import React from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import ReactDOM from 'react-dom';
import Page from './components/Page';
import { Provider } from 'react-redux';
import step from './reducers';
import thunk from 'redux-thunk';
import * as API from '../api';
import { getIsDirty } from './reducers/dirty';
import $ from 'jquery';
import { withCurrentReferer } from '../../../../../plugins/contextual-back';

export default function bind() {
  const createLogger = require('redux-logger');
  const logger = createLogger({
    collapsed: true,
  });

  const middleware = [thunk, logger];
  const enhancers = [];

  const root = document.getElementById('creation-step-3');
  const id = root.getAttribute('data-id');
  const customerId = root.getAttribute('data-customer');
  const store = createStore(
    step,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  const dirtyHandler = () => {
    if (getIsDirty(store.getState())) {
      $('#creation-step-3 form').addClass('dirty');
    }
  };

  store.subscribe(dirtyHandler);

  ReactDOM.render(
    <Provider store={store}>
      <Page id={parseInt(id, 10)} customerId={parseInt(customerId, 10)} />
    </Provider>,
    root
  );

  const update = (id, step, next) => {
    const form = store.getState().form.form;
    const infosArray = Object.keys(form.infos).map(key => {
      return form.infos[key];
    });

    API.update(id, step, { infos: infosArray }, next).then(res =>
      window.location.replace(withCurrentReferer(res.url))
    );
  };

  const cleanDirty = () => $('#creation-step-3 form').removeClass('dirty');

  const saveButton = document.getElementById('bt-save');
  const saveNextButton = document.getElementById('bt-save-next');
  if (saveButton) {
    const id = saveButton.getAttribute('data-id');
    const step = saveButton.getAttribute('data-step');
    saveButton.onclick = () => {
      cleanDirty();
      update(id, step, false);
    };
  }
  if (saveNextButton) {
    const id = saveNextButton.getAttribute('data-id');
    const step = saveNextButton.getAttribute('data-step');
    saveNextButton.onclick = () => {
      cleanDirty();
      update(id, step, true);
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step3/index.js